const Fetcher = require('od-modules/utils/fetcher');
const loginvalidator = require('od-modules/users/login_validator');
const socialLogin = require('od-modules/users/social_login');
const trackingUtils = require('od-modules/utils/tracking.utils');
const recaptchaManager = require('od-modules/users/recaptcha');
const ssoUtils = require('od-modules/utils/sso.utils');
const socialLoginButtons = {
    facebook: require('components/user_area/social_buttons/facebook_login_button.html'),
    google: require('components/user_area/social_buttons/google_login_button.html'),
};
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const appTouchpointFactory = require('components/app_download/app_touchpoint/js/main');

module.exports = withRenderedMain(BaseView.extend({
    errorMaxLength: 50,
    sendingWaitingPopup: null,
    waitingWheelDialog: null,
    initialize: function() {
        this.$el.find('.login_user_with_facebook').append(this.getSocialLoginButtonTemplate('facebook'));
        this.$el.find('.login_user_with_google').append(this.getSocialLoginButtonTemplate('google'));

        socialLogin.init(Odigeo._.bind(this._socialLogin, this), Odigeo._.bind(this._showSocialLoginError, this),
            this.id, this.$el.find(this.selectors.socialLoginContainer).data('pattern'));

        this.waitingWheelDialog = Odigeo.UIElements.createDialog({
            content: this.keys.registerFormSending,
            dialogClasses: 'od-login-layer-notifications',
            imageClass: 'waiting-wheel',
        });

        if (Odigeo.AB.isRecaptchaEnabled) {
            if (recaptchaManager.isGRecaptchaLoaded) {
                this.renderCaptcha();
            } else {
                recaptchaManager.init();
            }
        }

        if (this.$el.find('#app-touchpoint-register').length > 0) {
            appTouchpointFactory.create({
                id: 'app-touchpoint-register',
                options: {
                    selector: 'register',
                    trackAction: 'app_banner',
                    trackCategory: 'sso_register',
                    trackLabel: 'app_download_middle',
                },
            });
        }
    },

    selectors: {
        emailInfo: '.email_info',
        createUserGenericError: '.create_user_generic_error',
        emailInput: '.email_input',
        passwordInput: '.password_input',
        passwordIcon: '.password_icon',
        registerSuccess: '#register-success',
        registerPage: '#register-page',
        userName: '.user_name',
        userEmail: '.user_email',
        accountRegistered: '.account_registered',
        hasAccount: '.has_account',
        registerUserWaiting: '.register_user_waiting',
        socialLoginContainer: '.social_register_container',
        receiveNewsletter: '.register_receivemore_checkbox[name="receiveNewsletter"]',
        loginFacebookButton: '.social_register_container .login_facebook_button',
        loginGoogleButton: '.login_google_button',
        loginFacebookError: '.social_register_container .login_facebook_error',
        loginGoogleError: '.login_google_error',
        loginSocialError: '.login_social_error',
        socialError: '.social_error',
        recaptchaWrapper: '.g_recaptcha_register',
        allInputs: '[data-name]:not([type="hidden"])',
        prismaInput: '.prisma_input_group',
    },
    events: {
        'tap .email_input': 'showEmailInfoMessage',
        'input .password_input': 'showPasswordCharsIcon',
        'tap .password_icon': 'changePasswordCharsViewer',
        'tap .open_login_button': 'showLoginForm',
        'tap .create_user_button': 'createUser',
        'tap .has_account': 'showLoginFormAlreadyRegister',
        'tap .info_protection': 'trackEventForLegalInfoLinks',
        'tap .info_terms': 'trackEventForLegalInfoLinks',
        'tap .register_go_home': 'goHome',
        'tap .login_facebook_button': 'onLoginFacebook',
        'tap .login_google_button': 'onLoginGoogle',
        'focus .prisma_input_group': 'onFocusInput',
        'blur .prisma_input_group': 'onBlurInput',
    },

    getSocialLoginButtonTemplate: function(type) {
        const template = Odigeo._.template(socialLoginButtons[type], Odigeo.Utils.getTmplSettings({variable: 'data'}));
        return template({keys: this.keys});
    },

    onFocusInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).addClass('focused');
    },

    onBlurInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).removeClass('focused');
    },

    onLoginGoogle: function() {
        Odigeo.Session.set('loginPassword', 'google');
        this._trackEvent('create_account_google');
        this.checkLoginGoogleState();
    },

    onLoginFacebook: function() {
        Odigeo.Session.set('loginPassword', 'facebook');
        this._trackEvent('create_account_facebook');
        this.checkLoginFacebookState();
    },

    trackEventForLegalInfoLinks: function(e) {
        const label = $(e.currentTarget).hasClass('info_protection') ? 'links_open_DataProtectionPolicy' : 'links_open_GeneralConditions';
        this._trackEvent(label);
    },

    goHome: function() {
        Odigeo.Utils.goToApplicationHome();
    },

    checkLoginFacebookState: function() {
        socialLogin.getLoginStatus(this.id);
        this.clearErrors();
    },

    checkLoginGoogleState: function() {
        socialLogin.getLoginStatusGoogle(this.id);
        this.clearErrors();
    },

    showEmailInfoMessage: function(e) {
        this.$el.find(this.selectors.emailInfo).removeClass('hidden');
        $(e.target).off();
    },

    _showInProgressInfoModal: function() {
        this.$el.find(this.selectors.modalView).addClass('active');
        this.$el.find(this.selectors.registerUserWaiting).removeClass('odf-hidden');
    },

    _hideInProgressInfoModal: function() {
        this.$el.find(this.selectors.modalView).removeClass('active');
        this.$el.find(this.selectors.registerUserWaiting).addClass('odf-hidden');
    },

    showRegisterSuccess: function() {
        this.$el.find(this.selectors.registerPage).addClass('odf-hidden');
        this.$el.find(this.selectors.registerSuccess).removeClass('odf-hidden');
    },

    customizeRegisterSuccessWithUserData: function(userDTO) {
        this.$el.find(this.selectors.userName).text(userDTO.email).removeClass('hidden');
        this.$el.find(this.selectors.userEmail).text(userDTO.email);
    },

    showLoginForm: function(e, label) {
        e.stopPropagation();
        this._trackEvent(label || 'go_to_login');
        Odigeo.trigger(this.id + ':openLoginForm');
    },

    showLoginFormAlreadyRegister: function(e) {
        const label = 'sso_email_already_used_' + this.$el.find(this.selectors.hasAccount).data('track') + '_error_sing_in';
        this.showLoginForm(e, label);
    },

    changePasswordCharsViewer: function() {
        const $passwordInput = this.$el.find(this.selectors.passwordInput);
        this.$el.find(this.selectors.passwordIcon).find('.password_char_viewer').toggleClass('hidden');
        $passwordInput.attr('type',
            $passwordInput.attr('type') === 'password' ? 'text' : 'password'
        );
    },

    showPasswordCharsIcon: function(e) {
        this.$el.find(this.selectors.passwordIcon).removeClass('hidden');
        $(e.target).off();
    },

    createUser: function(e) {
        this._trackEvent('create_account_odigeo');
        if (e) {
            e.preventDefault();
        }
        this.clearErrors();
        if (this.checkValidity()) {
            Odigeo.UIElements.hideDialog(this.waitingWheelDialog);

            this.model.acceptsNewsletter = this.subscribeToNewsletterIsChecked();
            this.model.email = this.$el.find(this.selectors.emailInput).val();
            const password = this.$el.find(this.selectors.passwordInput).val();

            this.model.recaptchaCallbackData = Odigeo._.extend({
                'email': this.model.email,
                'password': password,
            }, this.model.acceptsNewsletter ? {'acceptsNewsletter': true} : {});

            this.hideGenericError();
            if (Odigeo.AB.isRecaptchaEnabled) {
                recaptchaManager.gRecaptchaExecute(this.model.recaptchaWidgetID);
            } else {
                this.triggerSubmitRequest();
            }
        }
    },

    subscribeToNewsletter: function(campaign = 'registration') {
        const NEWSLETTER_SUBSCRIPTION_ENDPOINT = '/travel/service/subscriptions/newsletter/subscribe';

        Fetcher.post(NEWSLETTER_SUBSCRIPTION_ENDPOINT, {email: this.model.email, campaign}).json();
    },

    recaptchaExecutionCallback: function() {
        this.model.recaptchaCallbackData.recaptchaResponse = recaptchaManager.gRecaptchaGetResponse(this.model.recaptchaWidgetID);
        this.triggerSubmitRequest();
    },

    triggerSubmitRequest: function() {
        Odigeo.trigger(this.id + ':submitUserRequest', {
            'action': this.model.registerActions['password'],
            'data': this.model.recaptchaCallbackData,
        });
    },

    _socialLogin: function(response) {
        this._showInProgressInfoModal();
        Odigeo.trigger(this.id + ':submitUserRequest', {
            'data': response,
            'action': this.model.registerActions[response.loginType],
        });
    },

    _showSocialLoginError: function(error, loginType) {
        const loginTypeFormatted = Odigeo._.startCase(loginType);
        const errorKey = error === 'requestError' ? 'error' : error;
        const errorText = this.$el.find(this.selectors['login' + loginTypeFormatted + 'Button']).data(errorKey);
        const $loginSocialError = this.$el.find(this.selectors.loginSocialError);

        this.clearErrors();
        this.$el.find(this.selectors[`login${loginTypeFormatted}Error`]).addClass('invalid');
        $loginSocialError.find('.error_message').text(errorText);
        $loginSocialError.addClass('invalid');
        this._hideInProgressInfoModal();
        this._trackEvent('sso_email_authentication_' + loginType + '_error');
    },

    checkValidity: function() {
        const fieldErrors = Odigeo._.reduce(this.$el.find(this.selectors.allInputs), function(accErrors, el) {
            return $.merge(accErrors, this._validateOneField($(el)));
        }, [], this);

        this.clearErrors();

        Odigeo._.each(fieldErrors, function(element) {
            this._showError(element);
        }, this);

        return Odigeo._.isEmpty(fieldErrors);
    },

    _showError: function(error, isLongMessage) {
        const $container = this.$el.find('[data-name=' + error.index + ']');
        const errText = $container.data(error.key.toLowerCase());
        const $inputWrapper = $container.closest('.input_wrapper');
        const isLongError = !Odigeo._.isUndefined(isLongMessage) ? !!isLongMessage : (errText.length > this.errorMaxLength);

        $inputWrapper.addClass(isLongError ? 'invalid-long' : 'invalid');
        if (Odigeo.AB.isCssVariationMobile) {
            $inputWrapper.find('.prisma-label-error').removeClass('odf-hidden');
        }
        $inputWrapper.find(isLongError ? '.error_long_message' : '.error_message').text(errText);
    },

    _validateOneField: function($target) {
        const errorLog = [];
        const value = $target.is('input') ? $target.val() : 'click';
        const valData = $target.data();
        const noAcceptLegacyPasswords = valData.validationType === 'password';

        if (Odigeo._.isEmpty(value) ||
            (valData && valData.validationType && !Odigeo.Utils.isValid(valData.validationType, value, noAcceptLegacyPasswords))) {
            errorLog.push({index: valData ? valData.name : '', key: Odigeo._.isEmpty(value) ? 'empty' : 'invalid'});
            this._trackEvent(valData.name === 'email' ? 'sso_email_incorrect_format_error' : 'sso_pwd_pci_compliance_error');
        }

        return errorLog;
    },

    onRegisterSuccess: function(data) {
        if (this.model.acceptsNewsletter) {
            this._trackEvent('sso_newsletter_checked');
            this.subscribeToNewsletter();
        }
        Odigeo.UIElements.hideDialog(this.waitingWheelDialog);
        if (data && data.userDTO && data.userDTO.email) {
            Odigeo.SessionScope.userData = data.userDTO;
            this.customizeRegisterSuccessWithUserData(data.userDTO);
        }
        Odigeo.trigger(this.id + ':registerSuccess');
        this.showRegisterSuccess();
        this._trackEvent('sso_successful_register_odigeo');

        // Analytics: virtual page tracking
        trackingUtils.trackPage('register/success', {
            funnel: false,
        });
        Odigeo.trigger('checkLazyImages');
    },

    onRegisterSuccessFacebook: function(data) {
        this.onSocialNetworkRegisterSuccess('sso_successful_register_facebook', data, 'facebook');
    },

    onRegisterSuccessGoogle: function(data) {
        this.onSocialNetworkRegisterSuccess('sso_successful_register_google', data, 'google');
    },

    onSocialNetworkRegisterSuccess: function(event, data, registerType) {
        this._trackEvent(event);
        this.model.acceptsNewsletter = this.subscribeToNewsletterIsChecked();
        this.model.email = data.userDTO ? data.userDTO.email : null;
        if (this.model.acceptsNewsletter) {
            this.subscribeToNewsletter();
        }
        socialLogin.addTravellerToAccount(data, this.id, 'home', registerType);
    },

    subscribeToNewsletterIsChecked: function() {
        return this.$el.find(this.selectors.receiveNewsletter)[0] &&
            !!this.$el.find(this.selectors.receiveNewsletter)[0].checked;
    },

    onRegisterError: function(data, social) {
        this._hideInProgressInfoModal();
        Odigeo.UIElements.hideDialog(this.waitingWheelDialog);
        if (Odigeo.AB.isRecaptchaEnabled) {
            recaptchaManager.gRecaptchaReset(this.model.recaptchaWidgetID);
        }
        let error = data && data.messageError && this.model.errors[data.messageError] ? this.model.errors[data.messageError] : 'requestError';
        const socialError = Odigeo._.includes(['permissions', 'authErrorFacebook', 'authErrorGoogle', 'format', 'tokenError',
            'socialError'], error);
        const subKey = function(key) {
            var splitKey = key.split('-').pop();
            return splitKey ? '-' + splitKey : '';
        };
        let trackError = 'odigeo';

        if (error.indexOf('emailExist') !== -1) {
            this._showError({'index': 'email', 'key': 'repeated' + subKey(error)});
            trackError = this.model.trackError[data.messageError] || trackError;
            this._trackEvent('sso_email_already_used_' + trackError + '_error');
            this.$el.find(this.selectors.accountRegistered).removeClass('hidden');
            this.$el.find(this.selectors.hasAccount).data('track', trackError);
        } else if (data.status === 0) {
            if (data.action.toLowerCase().indexOf('facebook') > -1) {
                this._showSocialLoginError(error, social);
            } else {
                this._showError({'index': 'password', 'key': 'connectionerror'});
            }
        } else if (error.indexOf('recaptcha') !== -1) {
            this.showGenericError('recaptchaerror');
            trackingUtils.trackEventWithCategory(Odigeo.Utils.isHomePage() ? 'home' : Odigeo.History.getPageNameFromFragment(),
                'recaptcha_error', 'odigeo_recaptcha_error_register');
        } else if (error === 'remoteError') {
            // error condition, clear password from input
            this.$el.find(this.selectors.passwordInput).val('');
            this.showGenericError('remoteerror');
        } else if (!socialError) {
            this._showError({'index': 'password', 'key': 'error'});
        } else {
            if (error.indexOf('Error') !== -1) {
                error = 'error';
            }
            this._showSocialLoginError(error, social);
        }
    },

    showGenericError: function(errAttr) {
        const $el = this.$el.find(this.selectors.createUserGenericError);
        $el.find('.msg_content').text($el.data(errAttr));
        $el.removeClass('odf-hidden');
    },

    hideGenericError: function() {
        this.$el.find(this.selectors.createUserGenericError).addClass('odf-hidden');
    },

    onCloseLoginForm: function() {
        Odigeo.trigger(this.id + ':closeLoginForm');
    },

    onRegisterErrorFB: function(data) {
        this.onRegisterError(data, socialLogin.socialLoginType.facebook);
    },

    onRegisterErrorGoogle: function(data) {
        this.onRegisterError(data, socialLogin.socialLoginType.google);
    },

    onUpdateAccountInfoSuccess: function(data) {
        if (!Odigeo._.isEmpty(data.displayName)) {
            ssoUtils.updateRememberMeCookieField('name', data.displayName);
        }
        Odigeo.Utils.goToApplicationHome();
    },

    onUpdateAccountInfoError: function() {
        // Not necessary to handle the errors
        Odigeo.Utils.goToApplicationHome();
    },

    loginWithFacebook: function() {
        Odigeo.trigger(this.id + ':facebookLogin');
    },

    loginWithGoogle: function() {
        Odigeo.trigger(this.id + ':googleLogin');
    },

    onAttachSocialLoginButton: function() {
        Odigeo.trigger(this.id + ':attachSocialLoginButton', this.$el.find(this.selectors.loginGoogleButton));
    },

    renderCaptcha: function() {
        if (Odigeo.AB.isRecaptchaEnabled && !this.model.recaptchaRendered) {
            this.model.recaptchaWidgetID = recaptchaManager.gRecaptchaRender(this.$el.find(this.selectors.recaptchaWrapper).get(0),
                Odigeo._.bind(this.recaptchaExecutionCallback, this), this.options.recaptchaSiteKey);
            this.model.recaptchaRendered = true;
        }
    },

    clearErrors: function() {
        loginvalidator.clearErrors(this.$el.find(this.selectors.allInputs), this.$el.find(this.selectors.socialError));
    },

    _trackEvent: function(label) {
        trackingUtils.trackEventWithCategory('sso_register', 'register_form', label);
    },
}));
